import {gql, graphql} from 'react-apollo';
import {compose} from 'redux';
import reject from 'lodash/reject';

import loadingSpinner from '../../shared/hoc/loadingSpinner';
import FilterPanel from '../components/FilterPanel';

const FILTER_QUERY = gql`
  query TicketFilterMetaQuery {
    ticketsFilterMeta {
      name
      label
      type
      picklist
    }
  }
`;

const container = compose(
  graphql(FILTER_QUERY, {
    props: ({data: {loading, error, ticketsFilterMeta}}) => ({
      loading,
      error,
      metadata: reject(ticketsFilterMeta || [], {type: 'Lookup'}) // let's not include the lookups for now
    })
  }),
  loadingSpinner
);

export default container(FilterPanel);



// WEBPACK FOOTER //
// ./src/tickets/containers/FilterPanelContainer.js